import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TitleBar from "components/TitleBar";

const BgSummaryByCount = ({ data, isLoading, isError }) => {

    const statusConfig = [
        { key: "activeCount", color: "#62B6CB", label: "Active" },
        { key: "releasedCount", color: "#5FA8D3", label: "Released" },
        { key: "renewedCount", color: "#238ccb", label: "Renewed" },
        { key: "encashedCount", color: "#1a6998", label: "Encashed" },
        { key: "expiredCount", color: "#124666", label: "Expired" },
    ];



    const categories = data.slice(0, -1).map((item) => item.bgType);

    const series = statusConfig.map((status) => ({
        name: status.label,
        color: status.color,
        data: data.slice(0, -1).map((item) => item[status.key] || null),
    }));

    const options = {
        chart: {
            type: "column",
            height: 400,
        },

        title: {
            text: "",
        },

        xAxis: {
            categories,
        },

        yAxis: {
            min: 0,
            title: {
                text: "Count",
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontSize: "10px",
                    fontWeight: "500",
                    color: "#374151",
                },
            },
        },

        tooltip: {
            headerFormat: "<b>{point.category}</b><br/>",
            pointFormat:
                "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
        },

        plotOptions: {
            column: {
                stacking: "normal",
                borderRadius: 4,
                pointWidth: 60,
                borderWidth: 0,
                dataLabels: {
                    enabled: false,

                },
                // point: {
                //     events: {
                //         click: function () {

                //             const category = this.category;
                //             const status = this.series.name;
                //             console.log({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //             handleCategoryClick({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //         },
                //     },
                // },
            },
        },

        series,

        credits: {
            enabled: false,
        },
    };

    return (
        <Box>
            <TitleBar
                title={"Bank Guarantee Count by Status"}
                description={"Status-wise count of bank guarantees"}
            />

            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                }}
            >

                {/* Right Side Chart */}
                <Grid size={12}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default BgSummaryByCount;